import { useSelector } from 'react-redux';
import { ReactNode } from 'react';
import { useLogger } from '@packages/shared/core/common/hooks';
import { useQuizStep } from '@packages/shared/core/quiz/hooks';
import { getGoal } from '@packages/shared/core/user/store/selectors';
import { answerKeys, ProcessingStepData, QuizScreenProps } from '@packages/shared/core/quiz/entities';

type ProcessingQuizStepProps = {
  id: string;
  renderQuizScreen: (stepData: QuizScreenProps) => ReactNode;
};

const ProcessingQuizStep = ({ id, renderQuizScreen }: ProcessingQuizStepProps) => {
  const logger = useLogger();
  const { next, stepData, userPreferences } = useQuizStep(id);

  const goal = useSelector(getGoal);

  if (!stepData) {
    // TODO add fallback
    logger.error(new TypeError(`Data for ${id} step not found`));
    return null;
  }

  const getGoalText = () => {
    switch (goal) {
      case answerKeys.findPartner:
        return 'find a perfect partner';
      case answerKeys.fixRelationship:
        return 'fix their relationship';
      case answerKeys.understandBetter:
        return 'understand themselves better';
      case answerKeys.giveGuidance:
        return 'give guidance on my future';
      case answerKeys.findEx:
        return 'find out about my ex';
      case answerKeys.giveAdvice:
        return 'give advice for my love life';
      default:
        return '';
    }
  };

  const onProcessingFinished = async () => next();

  return (
    <>
      {renderQuizScreen({
        onFinished: onProcessingFinished,
        userPreferences,
        goal: getGoalText(),
        ...(stepData as ProcessingStepData),
      })}
    </>
  );
};

export default ProcessingQuizStep;
